import styled from 'styled-components';

export default styled.button`
-moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }

  &:focus {
    outline: none;
  }

  all: initial;
  background-color: #0086C2;
  color: white;
  border: none;
  border-radius: 70px;
  font-weight: 500 !important;
  text-align: center;
  font-size: 18px !important;
  font-weight: bold !important;
  margin: 0 auto;
  display: block;
  cursor: pointer;
  transition: all .2s ease-in-out;
  padding: 15px 0;
  box-sizing: border-box;
  font-family: Roboto, sans-serif !important;

  &:hover{
    background-color: #005176;
  }

  &:active{
    background-color: #005176 !important;
  }
`;
